import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import MediaWrapper from "@/components/mediaWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";
import LinkWrapper from "@/components/linkWrapper";

export const query = graphql`
  fragment FeaturesGridWithOffsetIconsData on StrapiComponentFeaturesGridWithOffsetIcons {
    title
    topic
    description
    items {
      title
      description
      icon {
        ...StrapiMediaSubquery
      }
      link {
        url
      }
    }
  }
`;

function GridWithOffsetIcons({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="bg-background-white py-16 sm:py-24 lg:py-32">
      <div className="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
        {data.topic && (
          <h3 className="text-base font-semibold uppercase tracking-wider text-text-primary">
            <MarkdownWrapper text={data.topic} />
          </h3>
        )}
        {data.title && (
          <h2 className="mt-2 text-3xl font-extrabold tracking-tight text-text-primary sm:text-4xl">
            <MarkdownWrapper text={data.title} />
          </h2>
        )}
        {data.description && (
          <MarkdownWrapper
            text={data.description}
            markdownClassName="mt-5 max-w-prose mx-auto text-xl text-text-secondary"
            replaceParagraph={false}
          />
        )}
        {Boolean(data.items?.length) && (
          <div className="mt-20 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {data.items &&
              data.items.map((item, index) => (
                <LinkWrapper
                  to={item?.link?.url}
                  key={index}
                  className={`flow-root h-full rounded-lg bg-background-off-white px-6 py-6 ${
                    item?.link?.url ? "hover:bg-background-light-gray" : ""
                  }`}
                >
                  {item.icon && (
                    <div className="-mt-12 pb-6">
                      <div className="inline-flex items-center justify-center rounded-md bg-background-primary p-3 shadow-lg">
                        <MediaWrapper
                          media={item.icon}
                          objectFit="contain"
                          divClassName="h-6 w-6 text-text-white"
                          aria-hidden="true"
                        />
                      </div>
                    </div>
                  )}
                  {item.title && (
                    <h3 className="text-lg font-medium tracking-tight text-text-primary">
                      <MarkdownWrapper text={item.title} />
                    </h3>
                  )}
                  {item.description && (
                    <MarkdownWrapper
                      text={item.description}
                      markdownClassName="mt-5 text-base text-text-secondary"
                      replaceParagraph={false}
                    />
                  )}
                </LinkWrapper>
              ))}
          </div>
        )}
      </div>
    </div>
  );
}

GridWithOffsetIcons.propTypes = {
  data: PropTypes.object,
};

export default GridWithOffsetIcons;
